import { Table } from "@mantine/core";
import { SystemEmailRegistryEntry } from "../../../services/admin/systemEmails.service";
import { SystemEmailCategoryBadge } from "./SystemEmailCategoryBadge";

export function SystemEmailRegistryDetailCells({
  entry,
}: {
  entry: SystemEmailRegistryEntry;
}) {
  return (
    <Table.Td miw={190}>
      <SystemEmailCategoryBadge category={entry.category} />
    </Table.Td>
  );
}
